import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  RiNotificationLine,
  RiUserLine,
  RiSearchLine,
  RiSettings4Line,
  RiLogoutBoxRLine,
  RiFlashlightLine,
  RiArrowLeftLine,
} from "react-icons/ri";

const Navbar = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const userInfo = {
    name: "GANESH W",
    email: "ganesh@gmail.com",
    role: "Administrator",
    avatar: "GW",
    notifications: 7,
  };

  // Don't show back button on main dashboard
  const showBackButton = location.pathname !== "/";

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-20">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center gap-4 w-full">
          {showBackButton && (
            <button
              onClick={() => navigate(-1)}
              className="p-2 hover:bg-gray-100 rounded-lg text-gray-600 transition-colors"
              title="Go back"
            >
              <RiArrowLeftLine className="w-5 h-5" />
            </button>
          )}
          <div className="flex items-center flex-1">
            <div className="relative">
              <RiSearchLine className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all duration-200 w-64"
              />
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <button className="p-2 hover:bg-gray-100 rounded-lg relative group">
              <RiNotificationLine className="w-6 h-6 text-gray-600" />
              {userInfo.notifications > 0 && (
                <span className="absolute -top-1 -right-1 bg-primary-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {userInfo.notifications}
                </span>
              )}
              <div className="absolute right-0 mt-2 hidden group-hover:block">
                <div className="bg-gray-800 text-white text-sm py-1 px-2 rounded-md whitespace-nowrap">
                  {userInfo.notifications} new notifications
                </div>
              </div>
            </button>
            <div className="relative">
              <button
                className="p-1 hover:bg-gray-100 rounded-lg flex items-center space-x-2"
                onClick={() => setShowProfileMenu(!showProfileMenu)}
              >
                <div className="w-10 h-10 rounded-full bg-gradient-to-r from-primary-500 to-primary-600 flex items-center justify-center text-white font-medium shadow-md">
                  {userInfo.avatar}
                </div>
                <div className="hidden md:block text-left">
                  <div className="text-sm font-medium text-gray-700">
                    {userInfo.name}
                  </div>
                  <div className="text-xs text-gray-500">{userInfo.role}</div>
                </div>
                {/* <RiUserLine className="w-5 h-5 text-gray-400 hidden md:block" /> */}
              </button>
              {showProfileMenu && (
                <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-secondary-200 py-2">
                  <div className="px-4 py-2 border-b border-gray-100">
                    <div className="font-medium text-gray-800">
                      {userInfo.name}
                    </div>
                    <div className="text-sm text-gray-500">
                      {userInfo.email}
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      navigate("/profile");
                      setShowProfileMenu(false);
                    }}
                    className="w-full px-4 py-2 text-left text-secondary-700 hover:bg-secondary-50 flex items-center group"
                  >
                    <RiSettings4Line className="w-5 h-5 mr-2" />
                    <span className="flex-1">Profile Settings</span>
                    <span className="text-xs text-gray-400 group-hover:text-primary-500">
                      ⌘P
                    </span>
                  </button>
                  <button
                    onClick={() => navigate("/actions")}
                    className="w-full px-4 py-2 text-left text-secondary-700 hover:bg-secondary-50 flex items-center"
                  >
                    <RiFlashlightLine className="w-5 h-5 mr-2" />
                    Quick Actions
                  </button>
                  <button
                    onClick={() => {}}
                    className="w-full px-4 py-2 text-left text-danger-600 hover:bg-danger-50 flex items-center mt-1 border-t border-gray-100"
                  >
                    <RiLogoutBoxRLine className="w-5 h-5 mr-2" />
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
